import { render, staticRenderFns } from "./conflictReports.vue?vue&type=template&id=9c7c04d0"
import script from "./conflictReports.vue?vue&type=script&lang=js"
export * from "./conflictReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports